import React, { FC } from 'react'
import { Splide, SplideSlide } from '@splidejs/react-splide'
import classNames from 'classnames'
import { Image } from '@/atoms/Image'
import { ResponsiveBackgroundImage } from '@/atoms/ResponsiveBackgroundImage'
import { useTranslate } from '@/utils/translate/translate-client'
import useWindowSize from '@/utils/useWindowSize'
import { GTitleLG } from '@/views/PreSales/PreSalesGiveawayView/components/Typography'

const mobileHero = 'https://images.angelstudios.com/image/upload/v1736549658/hero-ship-img-01m.webp'
const desktopHero = 'https://images.angelstudios.com/image/upload/v1736548788/hero-ship-img-01d_1.webp'
const cardOne = 'https://images.angelstudios.com/image/upload/v1736540990/Card_1_You.webp'
const cardTwo = 'https://images.angelstudios.com/image/upload/v1736541016/Card_2_Teach.webp'

const alaska = 'https://images.angelstudios.com/image/upload/v1736547588/trip-img-04_1.webp'
const grandCanyon = 'https://images.angelstudios.com/image/upload/v1736547586/trip-img-02_2.webp'
const barrierReef = 'https://images.angelstudios.com/image/upload/v1736547585/trip-img-01_2.webp'
const safari = 'https://images.angelstudios.com/image/upload/v1736547765/trip-img-03_3.webp'

const locationImages = [barrierReef, grandCanyon, safari, alaska]

interface Props {
  onScrollToProducts: () => void
}
export const VacationInfo: FC<Props> = ({ onScrollToProducts }) => {
  const { innerWidth } = useWindowSize()
  const { t } = useTranslate('tickets')
  const isMobileWidth = innerWidth < 768

  return (
    <div className="giveaway-page flex w-full flex-col md:!mx-auto">
      <div className="mx-auto flex w-[200px] flex-col items-center gap-8 md:w-full md:flex-row md:justify-center">
        <Image src={cardOne} width={200} height={300} alt="card" />
        <div className="h-[2px] w-full bg-core-gray-300 md:!h-[180px] md:!w-[2px]" />
        <Image src={cardTwo} width={200} height={300} alt="card" />
      </div>

      <GTitleLG color="giveaway-text-primary-light" className="mb-1 mt-16 uppercase">
        {t('whereWillYouGo', 'Where will you go?')}
      </GTitleLG>

      <div className="hidden grid-cols-2 grid-rows-2 gap-x-1 md:grid">
        {locationImages.map((src, index) => {
          return (
            <div
              key={src}
              style={{ aspectRatio: 3 / 2 }}
              className={classNames('relative w-full', index > 1 && '-mt-4')}
            >
              <Image src={src} fill className="object-cover" alt="location" />
            </div>
          )
        })}
      </div>

      <Splide
        id="giveaway-page"
        className="!z-50 md:hidden"
        hasTrack={true}
        options={{
          arrows: false,
          autoplay: true,
          speed: 600,
          type: 'loop',
          pagination: true,
          paginationDirection: 'ltr',
          interval: 3000,
          perMove: 1,
          perPage: 1,
          classes: { pagination: 'giveaway !flex !justify-center -mt-8' },
        }}
      >
        {locationImages.map((src) => {
          return (
            <SplideSlide key={src}>
              <div style={{ aspectRatio: 3 / 2 }} className="relative w-full">
                <Image src={src} fill className="object-contain" alt="location" />
              </div>
            </SplideSlide>
          )
        })}
      </Splide>

      <div
        onClick={onScrollToProducts}
        style={{ aspectRatio: isMobileWidth ? 3 / 2 : 2 }}
        className="relative mt-12 w-full cursor-pointer md:mt-0"
      >
        <ResponsiveBackgroundImage
          className="bg-cover md:bg-contain"
          srcUrls={{
            xs: mobileHero,
            sm: mobileHero,
            md: desktopHero,
            lg: desktopHero,
            xl: desktopHero,
            '2xl': desktopHero,
          }}
          src={mobileHero}
        />
      </div>
    </div>
  )
}
